
// /scripts/quickbuy-manager-corrected.js

class QuickBuyManager {
  constructor() {
    this.market = marketHandle || "{{ localization.market.handle }}";
    console.log('QuickBuyManager initialized with market:', this.market);
    this.injectStyles();
    this.attachEventListeners();
    this.addElements(3);  // Automatically add 3 product input rows on load
  }

  getMarketKey() {
    switch (this.market) {
      case "europe": case "gb": return "color_name_en";
      case "france": return "color_name_fr";
      case "italy": return "color_name_it";
      case "de": return "color_name_de";
      case "portugal": return "color_name_pt";
      case "netherlands": return "color_name_nl";
      default: return "color_name_en";
    }
  }

  createDomElement(index) {
    const quickBuyDiv = document.getElementById('quickbuy-new');
    const div = document.createElement("div");
    div.innerHTML = `
      <div class="grid__item one-half medium-up--one-quarter u-spaceBottom1" style="padding-left: 5%;">
        <input placeholder="Reference #" style="width: 100%;" type="text" id="new-referencia-${index}">
      </div>
      <div class="grid__item one-half medium-up--one-quarter u-spaceBottom1" style="padding-left: 5%;">
        <select style="width: 100%;"  id="new-colorR-${index}">
          <option>Select Color</option>
        </select>
      </div>
      <div class="grid__item one-half medium-up--one-quarter u-spaceBottom1" style="padding-left: 5%;">
        <select style="width: 100%;"  id="new-tallaR-${index}">
          <option>Select Size</option>
        </select>
      </div>
      <div class="grid__item one-half medium-up--one-quarter u-spaceBottom1" style="padding-left: 5%;">
        <div style=" border-radius: 20px; border: 1px solid; border-color: var(--colorBorder); width: max-content;"  class="quantity-control">
          <button style="font-size: 1.5em; padding: 4px 12px;" type="button" class="quantity-btn" data-action="decrease" data-index="${index}" >-</button>
          <input style="border: none; max-width: 40px; text-align: center; padding: 4px"type="number" id="new-cantidad-${index}" value="1" min="1" readonly class="quantity-number">
          <button style="font-size: 1.2em; padding: 4px 12px;" type="button" class="quantity-btn" data-action="increase" data-index="${index}">+</button>
        </div>
      </div>
      <label style="display:none;" id="new-idR-${index}"></label>
    `;
    div.classList.add('mobile-quickbuy-section');
    quickBuyDiv.appendChild(div);
  }

  injectStyles() {
    const styles = `
      .toast {
        position: fixed;
        bottom: 20px;
        right: 20px;
        padding: 15px 20px;
        border-radius: 5px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        color: white;
        opacity: 0;
        animation: fadeInOut 3s ease-in-out;
        z-index: 9999;
      }
      .toast.success { background-color: #28a745; }
      .toast.error { background-color: #dc3545; }

      @media only screen and (max-width: 767px){
        .mobile-quickbuy-section{
          padding-bottom: 20px;
          border-bottom: 1px solid silver;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 16px;
        }
        .grid__item {
          padding-left: auto !important;
        }
      }
    `;
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
  }

  attachEventListeners() {
    const quickBuyContainer = document.getElementById('quickbuy-new');

    if (quickBuyContainer) {
      quickBuyContainer.addEventListener('keyup', (e) => {
        if (e.target && e.target.matches("input[id^='new-referencia-']")) {
          this.debounce(() => this.getColor(e.target), 300)();
        }
      });

      quickBuyContainer.addEventListener('change', (e) => {
        if (e.target && e.target.matches("select[id^='new-colorR-']")) {
          this.getTalla(e.target);
        }
      });

      quickBuyContainer.addEventListener('change', (e) => {
        if (e.target && e.target.matches("select[id^='new-tallaR-']")) {
          this.getID(e.target);
        }
      });
      
      quickBuyContainer.addEventListener('click', (e) => {
        if (e.target && e.target.matches(".quantity-btn")) {
          const action = e.target.getAttribute("data-action");
          const index = e.target.getAttribute("data-index");
          this.updateQuantity(index, action);
        }
      });
    }

    document.getElementById('new-buttonadd')?.addEventListener('click', () => this.addCart());
    document.querySelector('.new-btn--secondary')?.addEventListener('click', () => this.addElements());
  }

  updateQuantity(index, action) {
    const quantityInput = document.getElementById(`new-cantidad-${index}`);
    let currentValue = parseInt(quantityInput.value);
  
    if (action === "increase") {
      quantityInput.value = currentValue + 1;
    } else if (action === "decrease" && currentValue > 1) {
      quantityInput.value = currentValue - 1;
    }
  }

  debounce(func, delay) {
    let debounceTimer;
    return function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, arguments), delay);
    };
  }

  addElements(count = 1) {
    const currentRows = document.querySelectorAll("[id^='new-referencia-']").length;
    for (let i = 0; i < count; i++) {
      this.createDomElement(currentRows + i);
    }
  }

  async searchSKU(value) {
    try {
      const response = await fetch(`/search?type=product%2C&options[prefix]=last&q=${value}*`);
      const content = await response.text();
      const parser = new DOMParser();
      const divResult = parser.parseFromString(content, 'text/html').getElementById("divresultado");
      if (!divResult) throw new Error("divresultado not found");
      const rawText = divResult.innerText;
      return JSON.parse(rawText);
    } catch (error) {
      console.error("Error in searchSKU:", error);
      return {};
    }
  }

  async fetchVariantTranslation(variantId) {
    const key = this.getMarketKey();
    try {
      const response = await fetch(`https://infinity.leonisa.com/webstore-service-utilities/fetch-metafields?variantId=${variantId}`);
      if (!response.ok) throw new Error("Failed to fetch translation");
      const data = await response.json();
      if (data.metafields && Array.isArray(data.metafields)) {
        const translationEntry = data.metafields.find(meta => meta.key === key);
  
        // Return the translated color or null if not found
        return translationEntry ? translationEntry.value : null;
      }
      return null;
    } catch (error) {
      console.error(`Error fetching translation for variant ID ${variantId}:`, error);
      return null;
    }
  }

  async getColor(element) {
    const idElement = element.id.split('-')[2];
    const referencia = document.getElementById(`new-referencia-${idElement}`).value;

    try {
      const result = await this.searchSKU(referencia);
      const colorSet = new Set();
      const colorVariantPairs = [];

      result.products.forEach(product => {
        if (!colorSet.has(product.color)) {
          colorSet.add(product.color);
          colorVariantPairs.push({
            color: product.color,
            variantId: product.id
          });
        }
      });

      const translations = [];
      for (let pair of colorVariantPairs) {
        const translation = await this.fetchVariantTranslation(pair.variantId);
        translations.push(translation || pair.color);
      }

      const translatedColors = colorVariantPairs.map((pair, index) => ({
        color: pair.color,
        translation: translations[index]
      }));

      this.populateOptions(`new-colorR-${idElement}`, translatedColors, "Color");
    } catch (error) {
      console.error("Error in getColor:", error);
    }
  }

  // Populate size dropdown
  async getTalla(element) {
    const idElement = element.id.split('-')[2];
    const selectedColor = element.value;
    const referencia = document.getElementById(`new-referencia-${idElement}`).value;

    try {
      const result = await this.searchSKU(referencia);
      const sizes = result.products
        .filter(product => product.color === selectedColor)
        .map(product => product.talla);
      console.log('sizes: ' + sizes)
      this.populateOptions(`new-tallaR-${idElement}`, sizes, "Size");
    } catch (error) {
      console.error("Error in getTalla:", error);
    }
  }

  // Get product ID based on color and size
  async getID(element) {
    const idElement = element.id.split('-')[2];
    const selectedColor = document.getElementById(`new-colorR-${idElement}`).value;
    const selectedSize = element.value;
    const referencia = document.getElementById(`new-referencia-${idElement}`).value;

    try {
      const result = await this.searchSKU(referencia);
      const matchedProduct = result.products.find(product =>
        product.color === selectedColor && product.talla === selectedSize
      );

      if (matchedProduct) {
        document.getElementById(`new-idR-${idElement}`).innerHTML = matchedProduct.id;
        this.enableAddButton();
      }
    } catch (error) {
      console.error("Error in getID:", error);
    }
  }

  enableAddButton() {
    const button = document.getElementById("new-buttonadd");
    if (button) button.removeAttribute("disabled");
  }

  async addCart() {
    const quickBuyContainer = document.getElementById("quickbuy-new");
    const items = quickBuyContainer.querySelectorAll("label[id^='new-idR-']");
    const productsToAdd = [];
  
    // Collect all variant IDs and their quantities
    items.forEach((itemLabel, index) => {
      const variantId = itemLabel.innerHTML;
      const quantityInput = document.getElementById(`new-cantidad-${index}`);
      const quantity = quantityInput ? quantityInput.value : 0;
      const errorMessage = document.getElementById(`error-${index}`)?.innerHTML;
  
      // Validate variant ID, quantity, and absence of errors
      if (variantId && quantity > 0 && !errorMessage) {
        productsToAdd.push({
          id: variantId,
          quantity: parseInt(quantity, 10),
        });
      }
    });
  
    // Abort if no valid items
    if (productsToAdd.length === 0) {
      console.warn("No valid products to add to the cart.");
      return;
    }
  
    let cartUpdated = false;
  
    // Add each product to the cart individually
    for (let product of productsToAdd) {
      const formData = `quantity=${product.quantity}&form_type=product&id=${product.id}`;
  
      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
        });
  
        const data = await response.json();
  
        if (data.status !== 422) {
          document.dispatchEvent(new CustomEvent("cart:build"));
          document.dispatchEvent(new CustomEvent("cart:open"));
          cartUpdated = true;
        } else {
          console.error(`Failed to add variant ${product.id}:`, data);
        }
      } catch (error) {
        console.error(`Error adding variant ${product.id} to cart:`, error);
      }
    }
  
    // UI Refresh after successful cart update
    if (cartUpdated) {
      const currentPage = window.location.pathname;
  
      if (currentPage.includes("cart")) {
        location.reload();
        window.scrollTo(0, 0);
      }
  
      document.getElementById("quickbuy-new").innerHTML = "";
      this.addElements();  // Reset input fields
      document.getElementById("new-buttonadd").setAttribute("disabled", "");
    }
  }
  

  populateOptions(elementId, items, placeholder) {
    const select = document.getElementById(elementId);
    select.innerHTML = `<option>${placeholder}</option>`;
    items.forEach(item => {
      const option = document.createElement("option");
      option.value = item.color || item;
      option.textContent = item.translation || item;
      select.appendChild(option);
    });
  }
}

// Initialize QuickBuyManager
document.addEventListener('DOMContentLoaded', () => {
  window.quickBuyManager = new QuickBuyManager();
});
